// createGamePlatform — the single wiring point every Betohalics game calls.
// Selects online vs kiosk implementations behind the shared ports so the game
// code is identical in both modes. ONLINE is the default and reproduces the
// pre-platform behavior exactly.

import { resolveDeploymentMode } from './deploymentMode';
import { loadGameConfig } from './gameConfig';
import { createEventBus, PLATFORM_EVENTS } from './events';
import { createDiagnosticsLogger } from './diagnostics';
import { WebWalletAdapter } from './wallet/webWalletAdapter';
import { KioskWalletAdapter } from './wallet/kioskWalletAdapter';
import { MachineServiceClient } from './machineService/machineServiceClient';
import { PLATFORM_CONTRACT_VERSION } from './version';

export function createGamePlatform({
  gameId,
  gameVersion,
  gameSlug,
  denominations,
  betOptions,
  mode: forcedMode,
} = {}) {
  const mode = forcedMode || resolveDeploymentMode();
  const config = loadGameConfig({ gameId, gameVersion, gameSlug, denominations, betOptions });
  const bus = createEventBus();
  const logger = createDiagnosticsLogger({ mode, gameId });
  const machine = new MachineServiceClient({ bus, logger });

  let wallet;
  if (mode === 'kiosk') {
    // Stub: online-capable backend wallet is still used for settlement while
    // the cabinet is online; physical credit in/out route through `machine`.
    const backendWallet = new WebWalletAdapter({
      apiBase: config.endpoints.apiBase,
      gameSlug: config.gameSlug,
    });
    wallet = new KioskWalletAdapter({ machineService: machine, backendWallet });
  } else {
    wallet = new WebWalletAdapter({
      apiBase: config.endpoints.apiBase,
      gameSlug: config.gameSlug,
    });
  }

  logger.event('platform_created', { mode, gameId, contract: PLATFORM_CONTRACT_VERSION });

  return {
    mode,
    config,
    bus,
    logger,
    wallet,
    machine,
    events: PLATFORM_EVENTS,
    contractVersion: PLATFORM_CONTRACT_VERSION,
  };
}
